import React from 'react'
import Helmet from 'react-helmet'

export default class HelmetWrapper extends React.Component {
  render() {
    const { metaTitle, metaDescription } = this.props

    return (
      <Helmet
        title={metaTitle}
        meta={[
          { name: 'og:title', content: metaTitle },
          { name: 'description', content: metaDescription },
          { name: 'og:description', content: metaDescription },
        ]}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/partials/helmet-wrapper.js